
import helper from "@/asstes/help.js";
import { Encrypt, Decrypt } from "@/asstes/utils.js";
import md5 from "js-md5";
import { defineComponent, ref, onMounted, computed, onDeactivated } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import TanChuang from "@/components/tanchuang/TanChuang.vue";
import SIdentify from "@/components/yanZheng/iDentify.vue";
import router from "@/router";

export default defineComponent({
  name: "LoginView",
  components: {
    TanChuang,
    SIdentify,
  },
  setup() {
    let identifyCodes = "1234567890";
    let identifyCode = ref("3212");
    let usercode = ref("");
    let eyeimg=ref("");
    let password=ref("password");
    let shownopwd=()=>{
      if(password.value=="password"){
        password.value="text";
        eyeimg.value=require("../asstes/img/eyeo.png");
      }
      else{
         password.value="password";
        eyeimg.value=require("../asstes/img/eye.png");
      }
    };
    let store = useStore();
    let zhuangtai = computed(() => {
      return store.state;
    });
    //产生一个5随机数存起来

    let dl = () => {
      store.commit("setClassa", "on");
    };
    let sm = () => {
      store.commit("setClassb", "on");
    };
    let xiazai = () => {
      store.commit("xiazai");
    };
    let closexiazai = () => {
      store.commit("closexiazai");
    };
    let dot = (n: number) => {
      index.value = n;
      store.commit("qihuan", index.value);
    };
    const timer = ref(0);
    const index = ref(0);
    let username = ref("");
    let userpwd = ref("");
    let content = ref("弹窗信息");
    let tishi = ref("弹窗信息");
    let showno = ref("tanchuangno");
    let errbg = ref("dlnone");
    let version = ref("");
    let versiontype = ref("");
    let unitname=ref("");
    let icp=ref("");
    let proname=ref("");
    let guest = ref("");
    let nlogin = () => {
      let timestamp = new Date().getTime();
      let moduleid = "2001";
      let params = {
        loginname: "guest",
        password: "guest",
        equip: "WEB",
      };
      let jmparams = Encrypt(params);
      let sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
            "clientAPI.do?moduleid=" +
            moduleid +
            "&timestamp=" +
            timestamp +
            "&params=" +
            jmparams +
            "&sign=" +
            sign,
          {}
        )
        .then(function (response) {
          let dda = response.data;
          let datas = Decrypt(dda);
          let datan = JSON.parse(datas);

          if (datan.result == 1) {
            showno.value = ref("tanchuangx").value;
            content.value = ref("登录成功").value;
            setTimeout(() => {
              showno.value = ref("tanchuangno").value;
            }, 2000);
            userlog(username.value, "登录", "WEB");
            localStorage.setItem("loginname", "guest");
            localStorage.setItem("userid", datan.data.userid);
            localStorage.setItem("username", datan.data.username);
            localStorage.setItem("password", Encrypt("guest"));
            store.commit("getpanduqu");
            router.push("/index");
          } else {
            errbg.value = ref("errbg").value;
            tishi.value = ref(" 该用户不存在，或密码错误，请重新输入！").value;
            setTimeout(() => {
              errbg.value = ref("dlnone").value;
            }, 2000);
          }
        });
    };
    let login = () => {
      if (zhuangtai.value.random == usercode.value) {
        if (username.value != "" && userpwd.value != "") {
          let timestamp = new Date().getTime();
          let moduleid = "2001";
          let params = {
            loginname: username.value,
            password: userpwd.value,
            equip: "WEB",
          };
          let jmparams = Encrypt(params);
          let sign = md5(timestamp + moduleid + jmparams);
          axios
            .post(
              helper.webUrl +
                "clientAPI.do?moduleid=" +
                moduleid +
                "&timestamp=" +
                timestamp +
                "&params=" +
                jmparams +
                "&sign=" +
                sign,
              {}
            )
            .then(function (response) {
              let dda = response.data;
              let datas = Decrypt(dda);
              let datan = JSON.parse(datas);
              if (datan.result == 1) {
                showno.value = ref("tanchuangx").value;
                content.value = ref("登录成功").value;
                setTimeout(() => {
                  showno.value = ref("tanchuangno").value;
                }, 2000);
                userlog(username.value, "登录", "WEB");
                localStorage.setItem("loginname", username.value);
                localStorage.setItem("userid", datan.data.userid);
                localStorage.setItem("username", datan.data.username);
                localStorage.setItem("password", Encrypt(userpwd.value));
                store.commit("getpanduqu");
                let timestamp = new Date().getTime();
                let moduleid = "2006";
                let params = {
                  loginname: username.value,
                };
                let jmparams = Encrypt(params);
                let sign = md5(timestamp + moduleid + jmparams);
                axios
                  .post(
                    helper.webUrl +
                      "clientAPI.do?moduleid=" +
                      moduleid +
                      "&timestamp=" +
                      timestamp +
                      "&params=" +
                      jmparams +
                      "&sign=" +
                      sign,
                    {}
                  )
                  .then(function (response) {
                    let dda = response.data;
                    let datas = Decrypt(dda);
                    let datan = JSON.parse(datas);
                    localStorage.setItem("user", JSON.stringify(datan.data));
                    router.push("/index");
                  });
              } else {
                errbg.value = ref("errbg").value;
                tishi.value = ref(
                  " 该用户不存在，或密码错误，请重新输入！"
                ).value;
                setTimeout(() => {
                  identifyCode.value = "";
                  makeCode(identifyCodes, 4);
                  errbg.value = ref("dlnone").value;
                }, 1200);
              }
            });
        } else {
          errbg.value = ref("errbg").value;
          tishi.value = ref(" 用户名密码不能为空！").value;
          setTimeout(() => {
            identifyCode.value = "";
            makeCode(identifyCodes, 4);
            errbg.value = ref("dlnone").value;
          }, 1200);
        }
      } else {
        errbg.value = ref("errbg").value;
        tishi.value = ref(" 验证码错误！ ").value;
        setTimeout(() => {
          errbg.value = ref("dlnone").value;
        }, 2000);
      }
    };

    let duqupeizhi = () => {
      var timestamp = new Date().getTime();
      var moduleid = "0001";
      var params = {};
      var jmparams = Encrypt(params);
      var sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
            "clientAPI.do?moduleid=" +
            moduleid +
            "&timestamp=" +
            timestamp +
            "&params=" +
            jmparams +
            "&sign=" +
            sign,
          {}
        )
        .then(function (res) {
          //添加浏览者信息
          let dda = res.data;
          let datas = Decrypt(dda);
          let datan = JSON.parse(datas);
          if (datan.result == "1") {
            version.value = datan.data.version;
            versiontype.value = fanhuimingzi(datan.data.versiontype);
            unitname.value=datan.data.copyright;
            icp.value=datan.data.icp;
            proname.value=datan.data.productname;
            guest.value = datan.data.guest;
          }
        })
        .catch(function (error) {
           console.log(error);
        });
    };
    let fanhuimingzi=(zhi)=>{
      let fhz="";
      let arr=["F0","S0","S1","S2","S3","S23","S123","Z1","Z2","S4","E1"];
      let arrname=["服务器版本，不需要互联网云盘标识","幼儿园版","小学版","初中版","高中版","完全中学版","九年义务教育版本","中职版","高职版","大学版","教育局版"];
      for(let i=0;i<arr.length;i++){
         if(arr[i]==zhi){
          fhz= arrname[i];
         }
      }
      return fhz;
    };
    let userlog = (loginname: string, descript: string, equip: string) => {
      var timestamp = new Date().getTime();
      var moduleid = "3018";
      var params = {
        loginname: loginname,
        descript: descript,
        equip: equip,
      };
      var jmparams = Encrypt(params);
      var sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
            "clientAPI.do?moduleid=" +
            moduleid +
            "&timestamp=" +
            timestamp +
            "&params=" +
            jmparams +
            "&sign=" +
            sign,
          {}
        )
        .then(function () {
          //添加浏览者信息
          // console.log(response);
        })
        .catch(function () {
          // console.log(error);
        });
    };

    const randomNum = (min, max) => {
      return Math.floor(Math.random() * (max - min) + min);
    };

    const makeCode = (o, l) => {
      for (let i = 0; i < l; i++) {
        identifyCode.value += o[randomNum(0, o.length)];
      }
    };

    const refreshCode = () => {
      identifyCode.value = "";
      makeCode(identifyCodes, 4);
    };

    onMounted(() => {
      eyeimg.value=require("../asstes/img/eye.png");
      duqupeizhi();
      identifyCode.value = "";
      makeCode(identifyCodes, 4);
      store.commit("random", identifyCode);
      //组件挂载时的生命周期执行的方法
      timer.value = window.setInterval(() => {
        // 其他定时执行的方法
        if (index.value > 1) {
          index.value = 0;
        }
        store.commit("qihuan", index.value);
        index.value = index.value + 1;
      }, 5000);

      var timestamp = new Date().getTime();
      var moduleid = "1003";
      var params = {};
      var jmparams = Encrypt(params);
      var sign = md5(timestamp + moduleid + jmparams);
      axios
        .post(
          helper.webUrl +
            "clientAPI.do?moduleid=" +
            moduleid +
            "&timestamp=" +
            timestamp +
            "&params=" +
            jmparams +
            "&sign=" +
            sign,
          {}
        )
        .then(function (res) {
          if (res.status == 200) {
            let dda = res.data;
            let datas = Decrypt(dda);
            let datan = JSON.parse(datas);
            if (datan.result == "1") {
              localStorage.setItem("notallow", datan.data);
            }
          }
        });
    });
    onDeactivated(() => {
      //离开当前组件的生命周期执行的方法
      window.clearInterval(timer.value);
    });
    return {
      dl,
      sm,
      xiazai,
      closexiazai,
      dot,
      userlog,
      zhuangtai,
      login,
      username,
      userpwd,
      usercode,
      content,
      showno,
      errbg,
      tishi,
      refreshCode,
      identifyCode,
      nlogin,
      duqupeizhi,
      version,
      versiontype,
      proname,
      icp,
      unitname,
      guest,
      shownopwd,
      eyeimg,
      password
    };  
  },
});
